/**
 * Presentational helpers for the Document Picture-in-Picture call
 * surface. Split out of InAppCallDialog so that file stays under the
 * 400-LOC ceiling. None of these components own state or connect to
 * the LiveKit SDK — purely view-layer.
 */

import { Button } from "@/components/ui/button";
import { PictureInPicture } from "@/components/ui/icons";

/** Solar picture-in-picture glyph for the "Pop out" button. */
export function PipIcon({ size = 14 }: { size?: number }) {
  return <PictureInPicture size={size} />;
}

/**
 * Inline placeholder shown in the in-app dialog while the call surface
 * is portaled out into a PiP window. Gives the user a visible "where
 * did my call go?" affordance and a way back without hunting for the
 * popout window's close button.
 */
export function PipPlaceholder({ onReturn }: { onReturn: () => void }) {
  return (
    <div className="h-full flex flex-col items-center justify-center gap-3 text-center px-6 text-sm text-muted-foreground">
      <PipIcon size={28} />
      <p>Call is in a separate window.</p>
      <Button variant="outline" size="sm" onClick={onReturn}>
        Return to in-app
      </Button>
    </div>
  );
}
